import { Colors } from "@zapier/design-system";
import {
  DEFAULT_CHATBOT_NODE_COLOR,
  DEFAULT_INTERFACE_NODE_COLOR,
  DEFAULT_NODE_COLOR,
  DEFAULT_TABLE_NODE_COLOR,
  DEFAULT_ZAP_NODE_COLOR,
  DEFAULT_AGENT_NODE_COLOR,
} from "@zapier/canvas-constants";
import { AssetType } from "@zapier/canvas-state";
const DEFAULT_COLORS_BY_ASSET_TYPE = {
  table: DEFAULT_TABLE_NODE_COLOR,
  interface: DEFAULT_INTERFACE_NODE_COLOR,
  chatbot: DEFAULT_CHATBOT_NODE_COLOR,
  zap: DEFAULT_ZAP_NODE_COLOR,
  agent: DEFAULT_AGENT_NODE_COLOR,
} as const;

type AssetTypeColorMap = typeof DEFAULT_COLORS_BY_ASSET_TYPE;

type Params = {
  assetType: AssetType | undefined;
  assetId: string | undefined;
  isDraftNotTemplateNode: boolean;
};

export function getDefaultColorForAssetType({
  assetType,
  assetId,
  isDraftNotTemplateNode,
}: Params): string {
  if (isDraftNotTemplateNode) {
    return Colors.GrayWarm3;
  }

  if (!assetType) {
    return DEFAULT_NODE_COLOR;
  }

  // IMPORTANT! Needs to go after !assetType check since we want assetType to be truthy
  if (!assetId) {
    return Colors.GrayWarm3;
  }

  return (
    DEFAULT_COLORS_BY_ASSET_TYPE[assetType as keyof AssetTypeColorMap] ??
    DEFAULT_NODE_COLOR
  );
}
